import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Router } from "@angular/router";
import { AuthenticationService } from "../authentication.service";
import { BaseComponent } from "../classes/BaseComponent";
import { Global } from "../classes/Global";
import { ValidationHelper } from "../helpers/ValidationHelper";
import { Log } from '../helpers/Log';
import { StorageHelper } from '../helpers/StorageHelper';

declare var jsSHA: any;

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  providers: [ AuthenticationService ]
})
export class RegisterComponent extends BaseComponent implements OnInit {

  shaObj: any;
  success: boolean = true;
  serverError: boolean = false;
  serverErrorMessage: string;
  email: string = "";
  username: string = "";
  @Input() referralCode: string = "";
  password: string = "";
  confirmPassword: string = "";
  emailInvalid: boolean = false;
  formIncomplete: boolean = false;
  passwordsDifferent: boolean = false;
  privacyPolicyError: boolean = false;
  referralCodeInputDisabled: boolean = false;

  @Output() onRegisterSuccess = new EventEmitter();

  constructor(private authenticationService: AuthenticationService,
    private router: Router) {
    super();
  }

  ngOnInit() {

    if (this.authenticationService.isLoggedIn()){
      this.router.navigate(['']);
    }
    else {
      if(this.referralCode) {
        this.referralCodeInputDisabled = true;
      }
    }

  }

  register() {

    this.privacyPolicyError = false;
    if (document.getElementById("privacyPolicyCheckbox")["checked"] === false) {
      this.privacyPolicyError = true;
      return;
    }

    //Check if all fields are filled
    if (!ValidationHelper.isValidString(this.username) || !ValidationHelper.isValidString(this.email) ||
      !ValidationHelper.isValidString(this.password) || !ValidationHelper.isValidString(this.confirmPassword)) {
        this.formIncomplete = true;
        return;
    }

    //Check if the email address is valid
    if (!ValidationHelper.isValidEmail(this.email)) {
      this.emailInvalid = true;
      return;
    }

    //Check if the passwords are identical
    if (this.password != this.confirmPassword) {
      this.passwordsDifferent = true;
      return;
    }

    //Re-initialize error flags
    this.formIncomplete = false;
    this.emailInvalid = false;
    this.success = true;
    this.serverError = false;

    //Do the register request
    this.authenticationService.register(Global.getCountry(), this.username, this.email, this.hashPassword(), Global.getStore(), this.referralCode).subscribe(
      result => { this.handleResult(result); }, error => { this.handleError(error); });

  }

  hashPassword(): string {
    this.shaObj = new jsSHA("SHA-256", "TEXT");
    this.shaObj.update(this.password);
    return this.shaObj.getHash("HEX");
  }

  handleResult(result) {
    if (result && result.status == "success") {
      this.onRegisterSuccess.emit();
      //clear saved invite code if one was used
      if(this.referralCode) {
        StorageHelper.getInstance().clear(StorageHelper.keys.inviteCode);
        StorageHelper.getInstance().clear(StorageHelper.keys.inviteCodeTime);
      }
    }
    else {

      this.success = false;
      this.serverError = true;
      this.serverErrorMessage = result && result.message ? result.message : this.getString('registrationFailed');
    }
  }

  handleError(error) {
    Log.getInstance().d(error);
  }

  onPasswordChange(password) {
    this.password = password;
  }

  onConfirmPasswordChange(password) {
    this.confirmPassword = password;
  }

  onConfirmPasswordEnterPressed() {
    // this.register();
  }

  onEmailChange(email) {
    this.email = email;
  }

  onUsernameChange(username) {
    this.username = username;
  }

  onReferralCodeChange(code: string) {
    this.referralCode = code;
  }

}
